<template>
    <div class="parent">
      <img src="../assets/orthogard/Paciente.png" alt="Imagen de fondo adicional" class="fondo-extra breathing" />
      
      <div class="div1">
        <img src="../assets/orthogard/Logo_2.png" alt="Imagen de prueba" />
      </div>
  
      <div class="imagen-centrada">
        <img src="../assets/orthogard/Orthogard.png" alt="Imagen centrada" class="breathing" />
      </div>
  
      <div class="imagen-derecha">
        <img src="../assets/orthogard/Textos_2.png" alt="Imagen derecha" />
      </div>
  
      <div class="imagen-izquierda">
        <img src="../assets/orthogard/uso.png" alt="Imagen izquierda" />
      </div>
  
      <div class="footer-texto">
        van Swaaij BWM, Slot DE, Van der Weijden GA, Timmerman MF, Ruben J. Fluoride, pH Value, and Titratable Acidity of Commercially Available Mouthwashes. <br> Int Dent J. 2024 Apr;74(2):260-267.
      </div>
  
    </div>
  </template>
  
  <script>
  export default {
    name: 'ResponsiveGrid'
  }
  </script>
  
  <style scoped>
  .parent {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: repeat(12, 1fr);
    grid-column-gap: 1px;
    grid-row-gap: 1px;
    width: 100%;
    height: auto;
    box-sizing: border-box;
    padding: 0;
    margin: 0;
    background: url('../assets/orthogard/Fondo_2.png') no-repeat center center;
    background-size: cover;
    position: relative;
  }
  
  /* Imagen adicional que ocupa todo el espacio del parent */
  .fondo-extra {
    position: absolute;
    top: 0;
    left: -211px;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0; /* detrás de todo */
  }
  
  /* Animación de respiro más intensa y lenta */
  @keyframes breathing {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.1); /* Más intenso */
    }
    100% {
      transform: scale(1);
    }
  }
  
  /* Aplicando la animación con una duración más larga */
  .breathing {
    animation: breathing 5s infinite ease-in-out;
  }
  
  /* Contenedor 1 */
  .div1 {
    grid-area: 1 / 1 / 2 / 4;
    min-height: auto;
    box-sizing: border-box;
    transform: translate(15%, 0);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 1;
  }
  
  .div1 img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  
  /* Imagen centrada */
  .imagen-centrada {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    height: auto;
  }
  
  .imagen-centrada img {
    width: 500px;
    height: auto;
    object-fit: contain;
  }
  
  /* Imagen centrada verticalmente al lado derecho */
  .imagen-derecha {
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translateY(-50%);
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    height: auto;
  }
  
  .imagen-derecha img {
    width: 390px;
    height: auto;
    object-fit: contain;
  }
  
  /* Imagen centrada verticalmente al lado izquierdo */
  .imagen-izquierda {
    position: absolute;
    top: 65%;
    left: 106px;
    transform: translateY(-50%);
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    height: auto;
  }
  
  .imagen-izquierda img {
    width: 300px; /* Ajusta según lo que necesites */
    height: auto;
    object-fit: contain;
  }
  
  /* Texto centrado al fondo */
  .footer-texto {
    position: absolute;
    bottom: 2%;
    left: 50%;
    transform: translateX(-50%);
    font-size: 12px;
    color: #555;
    font-family: 'ColgateReady-Regular';
    font-style: italic;
    text-align: center;
    z-index: 1;
    white-space: nowrap;
    padding: 5px 0;
  }
  
  
  @media (max-width: 1024px) and (max-width: 1160px) {
    .imagen-izquierda {
      left: 70px;
    }
  }
  </style>
  